import SHLogon from './src/logon.vue';


/**
 * ECharts绘制饼图或这圆环图
 */

/* istanbul ignore next */
SHLogon.install = function(Vue) {
  Vue.component('sh-logon', SHLogon);
};
export default SHLogon;


// WEBPACK FOOTER //
// ./src/components/base/view/cmps/logon/index.js